export const DEFAULT_UI_DATE_FORMAT = 'DD/MM/YYYY';
export const DEFAULT_UI_DATE_TIME_FORMAT = 'DD/MM/YYYY HH:mm:ss';
export const DEFAULT_API_DATE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_API_DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const MONTHS_PER_YEAR = 12;
export const DAYS_PER_YEAR = 365;
